import { render, staticRenderFns } from "./NonAcc.vue?vue&type=template&id=22aaae84&"
import script from "./NonAcc.vue?vue&type=script&lang=js&"
export * from "./NonAcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports